// This file is updated using the cli
// No not modify!
import React from 'react';
const Icon = (props) => {
    return (React.createElement("svg", Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 24 28", width: "24", height: "28" }, props),
        React.createElement("g", { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
            React.createElement("path", { fillRule: "nonzero", d: "M0.504380894,17.944 L3.566,17.944 L6,13.888 L8.434,17.944 L15,17.944 C15.553,17.944 16,17.496 16,16.944 C16,16.392 15.553,15.944 15,15.944 L9.566,15.944 L6,10 L2.434,15.944 L0.137199934,15.944 C0.060797301,15.3040563 0.0181479601,14.6552468 1.77635684e-15,14 L1.77635684e-15,7 L12,1.0658141e-14 L24,7 L24,14 C23.8428,19.6758331 21.8472,24.8686663 12,28 C4.49325494,25.6129129 1.54935768,22.0278142 0.504380894,17.944 Z" }))));
};
Icon.displayName = 'MedicalShield24x28';
export default Icon;
//# sourceMappingURL=MedicalShield24x28.js.map